import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { BirdieSessionDetail } from "@/features/birdie-monitor";

export const Route = createFileRoute("/birdie/sessions/$sessionId")({
  validateSearch: z.object({
    /** The open tab: conversation (default: what the person saw), steps, cards, events or details. */
    tab: z.string().optional().catch(undefined),
  }),
  component: BirdieSessionDetail,
});
